import React from 'react';
import { AllieIconProps } from '../../../components';

/* eslint-disable max-len */
export const UserIcon: React.FC<AllieIconProps> = ({
  size = '20',
  color = 'var(--allie-color-neutral-50)',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99996 10.625C7.12348 10.625 4.79163 12.9569 4.79163 15.8333V16.6667C4.79163 17.0118 4.5118 17.2917 4.16663 17.2917C3.82145 17.2917 3.54163 17.0118 3.54163 16.6667V15.8333C3.54163 12.2665 6.43312 9.375 9.99996 9.375C13.5668 9.375 16.4583 12.2665 16.4583 15.8333V16.6667C16.4583 17.0118 16.1785 17.2917 15.8333 17.2917C15.4881 17.2917 15.2083 17.0118 15.2083 16.6667V15.8333C15.2083 12.9569 12.8764 10.625 9.99996 10.625Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99996 3.95825C8.50419 3.95825 7.29163 5.17081 7.29163 6.66659C7.29163 8.16236 8.50419 9.37492 9.99996 9.37492C11.4957 9.37492 12.7083 8.16236 12.7083 6.66659C12.7083 5.17081 11.4957 3.95825 9.99996 3.95825ZM6.04163 6.66659C6.04163 4.48046 7.81383 2.70825 9.99996 2.70825C12.1861 2.70825 13.9583 4.48046 13.9583 6.66659C13.9583 8.85271 12.1861 10.6249 9.99996 10.6249C7.81383 10.6249 6.04163 8.85271 6.04163 6.66659Z"
        fill={color}
      />
    </svg>
  );
};
